import { NotificationType, currentEnv } from "../../Api/configs";
import ChatScreen from "../../screens/Auth/WebScreens/ChatScreen";

const API_GATEWAY_URL = currentEnv.notificationWebSocket;

interface Notification {
  type: string;
  data: any;
}

interface EventNotification {
  eventID: string;
  accessToken: string;
}

let socket: WebSocket | null = null;
let reconnectAttempts = 0;
const maxReconnectAttempts = 10;
const initialReconnectInterval = 2000;
let isManualDisconnect = false;

export const connectWebSocket = (
  userId: string,
  accessToken: string,
  onNotification: (notification: Notification) => void,
  onEventNotification: (eventNotification: EventNotification) => void
) => {
  isManualDisconnect = false;

  const connect = () => {
    if (reconnectAttempts >= maxReconnectAttempts) {
      console.error("Max reconnect attempts reached. Stopping reconnection.");
      return;
    }

    socket = new WebSocket(`${API_GATEWAY_URL}?accessToken=${accessToken}`);

    socket.onopen = () => {
      console.log("WebSocket connected");
      reconnectAttempts = 0;
      sendConnectMessage(userId);
    };

    socket.onmessage = (event) => {
      console.log("Message received", event);
      const data = JSON.parse(event.data);
      if (data.type === "success" || data.type === "dispute") {
        console.log("Event notification received:", data);
        onEventNotification(data);
      } else if (data) {
        console.log("Notification received:", data);
        onNotification(data);
      } else {
        console.warn("Unhandled event type received:", data);
      }
    };

    socket.onerror = (error) => {
      console.error("WebSocket error", error);
    };

    socket.onclose = () => {
      console.log("WebSocket disconnected");
      if (!isManualDisconnect) {
        attemptReconnect(
          userId,
          accessToken,
          onNotification,
          onEventNotification
        );
      }
    };
  };

  const attemptReconnect = (
    userId: string,
    accessToken: string,
    onNotification: (notification: Notification) => void,
    onEventNotification: (eventNotification: EventNotification) => void
  ) => {
    reconnectAttempts++;
    const reconnectInterval =
      initialReconnectInterval * Math.pow(2, reconnectAttempts - 1);
    const limitedInterval = Math.min(reconnectInterval, 30000);

    console.log(
      `Reconnecting... Attempt ${reconnectAttempts} in ${
        limitedInterval / 1000
      } seconds`
    );
    setTimeout(
      () =>
        connectWebSocket(
          userId,
          accessToken,
          onNotification,
          onEventNotification
        ),
      limitedInterval
    );
  };

  connect();

  // document.addEventListener("visibilitychange", () => {
  //   if (
  //     document.visibilityState === "visible" &&
  //     (!socket || socket.readyState === WebSocket.CLOSED)
  //   ) {
  //     console.log("Document visible. Reconnecting WebSocket.");
  //     connectWebSocket(
  //       userId,
  //       accessToken,
  //       onNotification,
  //       onEventNotification
  //     );
  //   } else if (document.visibilityState === "hidden" && socket) {
  //     console.log("Document hidden. Disconnecting WebSocket.");
  //     disconnectWebSocket();
  //   }
  // });
};

const sendConnectMessage = (userId: string) => {
  if (socket) {
    const message = {
      action: "connect",
      userId: userId,
    };
    socket.send(JSON.stringify(message));
  }
};

const sendDisconnectMessage = (userId: string) => {
  if (socket) {
    const message = {
      action: "disconnect",
      userId: userId,
    };
    socket.send(JSON.stringify(message));
  }
};

export const sendMessage = (
  senderId: string,
  notificationId: string,
  accessToken: string
) => {
  if (socket) {
    const message = {
      action: "sendNotification",
      data: {
        notificationId: notificationId,
        senderId: senderId,
        accessToken: accessToken,
      },
    };
    socket.send(JSON.stringify(message));
    console.log("Notification sent:", message);
  }
};

export const sendEventMessage = (eventNotification: EventNotification) => {
  if (socket) {
    const message = {
      action: "submitResult",
      data: eventNotification,
    };
    socket.send(JSON.stringify(message));
    console.log("Event notification sent:", message);
  }
};

export const disconnectWebSocket = () => {
  isManualDisconnect = true;
  if (socket) {
    socket.close();
    socket = null;
  }
};
